import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const Card = ({ children, className }) => (
    <div className={classNames("portal-card", className)}>{children}</div>
);

Card.propTypes = {
    className: PropTypes.string,
};
Card.defaultProps = {
    className: null,
};

export default Card;
